////////LIBRARY/////////
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

/////////STYLED/////////
const ColorItem = styled.span`
  color: ${props => (props.status_Color ? props.status_Color : 'black')};
  padding: 7px;
  font-size: 12px;
  font-weight: bold;
`
/////////STYLED/////////

class ColorBatStatus extends Component {

  ///////////////////////////////// RENDER ///////////////////////////////////////

  render() {
    const { children } = this.props
    const trl = this.context.store.getState().languages.siteLanguage.keys
    return (
      <ColorItem status_Color={children.color}>
        {trl[children.traductionKey]}
      </ColorItem>
    )
  }
}

ColorBatStatus.propTypes = {
  row: PropTypes.object,
  children: PropTypes.object
}

ColorBatStatus.contextTypes = {
  store: React.PropTypes.object.isRequired
}

export default ColorBatStatus
